import { AgentTaskStatus, agentTaskStatusFromJSON } from '~/protos/agents'
import { useTask } from '~/contexts/TaskContext'

export function useTaskStatusFromTaskObj(): AgentTaskStatus {
  const { task } = useTask()
  if (task != null) {
    return agentTaskStatusFromJSON(task.status)
  }
  return AgentTaskStatus.NONE_TASK_STATUS
}

export function useTaskStatus(): AgentTaskStatus {
  const taskStatusFromTaskObj = useTaskStatusFromTaskObj()
  return taskStatusFromTaskObj
}
